import { useMutation } from '@tanstack/react-query';

import { fixAndPromoteTicketApi } from '../api';

export default function useFixAndPromoteTicketMutation(options?: any) {
  return useMutation(fixAndPromoteTicketApi, options);
}
